// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"2f579398","219":"271c8a50","488":"1a09b84f","558":"dcaa6a72","572":"4278b47a","877":"4a56c9b3"}[chunkId] + ".chunk.js";
};